import React from 'react';
import { View, FlatList, RefreshControl } from 'react-native';
import { connect } from 'react-redux';

import Colors from "../../constants/Colors";
import PostComponent from "./PostComponent";

import {COMMENT_GET, MURAL_DELETE} from "./api/muralEndpoints";
import get from "../../api/methods/get";
import {CardTextArrow, ConfirmationDialogue, Refresh, SpinnerControl, SpinnerDialogue} from "../../components";
import deleteMethod from "../../api/methods/delete";
import NavBar from "../../components/NavBar";

class CommentsScreen extends React.Component {

    state = {
        isLoading: false,
        commentsData: [],
        fetchDate: null,

        showDeleteConfirmation: false,
        postIdToDelete: null,
        showDeleteProgress: false,
        deleteOperationComplete: false,
        isDeleting: false,
    };

    forceEmptyState = () => {
        this.setState({ isLoading: false, commentsData: [] });
    };

    getComments = async () => {

        if (this.state.isLoading) return;
        this.setState({ isLoading: true, commentsData: [] });

        try {

            const uniqueId = this.props.location.state.answerToId;
            let result = await get(COMMENT_GET(uniqueId));
            let json = await result.json();

            let comments = json.data.Items === null ? [] : json.data.Items;
            const postData = this.props.location.state.postData;
            comments.push(postData)

            this.setState({
                commentsData: comments,
                fetchDate: new Date().toISOString(),
            });

        } catch (e) {
            console.log(e);
        }

        this.setState({ isLoading: false });
    };

    showDeleteConfirmation = (postId) => {
        this.setState({ showDeleteConfirmation: true, postIdToDelete: postId });
    }

    handleDelete = async () => {
        if (this.state.isDeleting) return;
        this.setState({
            isDeleting: true,
            deleteOperationComplete: false,
            showDeleteProgress: true,
            showDeleteConfirmation: false,
        })

        try {
            const mainPostId = this.props.location.state.answerToId;
            const endpoint = MURAL_DELETE(mainPostId, this.state.postIdToDelete);
            await deleteMethod(endpoint);
            await this.getComments();
            this.setState({ deleteOperationComplete: true, postIdToDelete: null });

        } catch (e) {
            console.log(e);
        }

        this.setState({ isDeleting: false });
    }

    componentDidMount() {
        this.getComments()
    }

    render() {

        const answerToId = this.props.location.state.answerToId;
        const postData = this.props.location.state.postData;

        return (
            <NavBar title={"Comentários"}>

                <ConfirmationDialogue
                    isModalVisible={this.state.showDeleteConfirmation}
                    onClose={() => this.setState({ showDeleteConfirmation: false })}
                    onConfirm={this.handleDelete}
                    descriptionText={"Você tem certeza que deseja deletar este comentário?"}
                    titleText={"Deletar Comentário"}
                />

                <SpinnerDialogue
                    isModalVisible={this.state.showDeleteProgress}
                    onClose={() => this.setState({ deleteOperationComplete: false, showDeleteProgress: false, })}
                    isFinished={this.state.deleteOperationComplete}
                />

                <View style={{ width: 600 }}>
                    <SpinnerControl
                        isFetching={this.state.isLoading}
                        text={"Carregando comentários"}
                    />

                    {
                        this.state.isLoading === false &&
                        <CardTextArrow
                            text={"Novo comentário"}
                            showArrow={true}
                            onPress={() => this.props.history.push('/mural/comments/post', {
                                answerToId: answerToId, muralType: postData.type
                            })}
                        />
                    }

                    <FlatList
                        contentContainerStyle={{ marginTop: 30 }}
                        data={this.state.commentsData}
                        renderItem={({item}) => {
                            return <PostComponent
                                {...item}
                                postData={item}
                                postId={item.SK}
                                answerToId={item.commentOfPostId}
                                userId={item.creatorId}
                                currentUserId={this.props.userId}
                                authToken={this.props.authToken}
                                renderComment={false}
                                // handleDelete={this.showDeleteConfirmation}
                            />
                        }}
                        keyExtractor={(item) => item.SK.toString()}
                        refreshControl={
                            <RefreshControl
                                refreshing={this.state.isLoading}
                                onRefresh={() => this.getComments()}
                                colors={[Colors.spinnerColor]}
                                title={'Carregando Comentários'}
                            />
                        }
                    />
                </View>



            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        // authToken: state.auth.authData.IdToken,
        // userId: state.user.userId,
    }
};

export default connect(mapStateToProps, {})(CommentsScreen);
